<template>
  <div v-if="commodity != null">
    <!-- 头部 -->

    <Head></Head>
    <!-- 1688 -->
    <div class="main w">
      <div class="main-title">
        <h6>
          <span>{{ commodity.title }}</span>
        </h6>
        <!-- 商家 -->
        <!-- <div class="merchant">
          <span>{{ commodity.companyName }}</span>
          <span> <img src="../../assets/img/kefu.png" alt />联系客服 </span>
          <span> <img src="../../assets/img/shoucang.png" alt />关注商家 </span>
        </div> -->
      </div>
      <!-- 商品信息 -->
      <div class="details">
        <!-- 商品图片 -->
        <div class="details-img fl">
          <div class="img-box">
            <img :src="detailsimg" :class="{ img: img == true }" alt @click="img = !img" />
            <!-- <button class="btn" @click="characterRecognition">
              画像テキスト翻訳＆リサーチ
            </button> -->
          </div>
          <ul>
            <li v-for="(item, index) in commodity.imglist" :key="index" @click="showImg(item)">
              <img :src="item" alt />
            </li>
          </ul>
          <div class="functional">
            <p>
              元URLを確認：
              <a target="_blank" :href="'https://detail.tmall.com/item.htm?id=' + $route.query.iid
                " v-if="$route.query.type == 'tmall'"><img src="../../assets/img/tmall.png" alt="" /></a>
              <a target="_blank" :href="'https://item.taobao.com/item.htm?id=' + $route.query.iid
                " v-else-if="$route.query.type == 'taobao'"><img src="../../assets/img/taobao.png" alt="" /></a>
              <a target="_blank" :href="'https://detail.1688.com/offer/' + $route.query.iid + '.html'
                " v-else-if="$route.query.type == '1688'"><img src="../../assets/img/1688.png" alt="" /></a>
            </p>

            <a href="javascript:;" class="enshrine" @click="favoriteAdd">お気に入り <i class="el-icon-star-off"></i></a>
            <!-- <a href="javascript:;" style="margin-left: 150px"> </a> -->
            <button class="picbtn" @click="downloadImg(1)">
              画像ダウンロード
            </button>
            <button @click="shiping" class="picbtn" style="margin-left: 20px" v-if="shipinList != false">
              ムービーダウンロード
            </button>
            <!-- <a href="javascript:;">
              <img src="../../assets/img/guanzhu.png" alt /> 关注
            </a>
            <span>分享到:</span>
            <a href="javascript:;" class="share">
              <img src="../../assets/img/tb1.png" alt />
            </a>
            <a href="javascript:;" class="share">
              <img src="../../assets/img/tb2.png" alt />
            </a> -->
          </div>
        </div>
        <div class="details-select fl">
          <!-- 商品标题 -->
          <h3>{{ commodity.title }}</h3>
          <p style="color: #f3c622">{{ commodity.title }}</p>
          <!--  商品单价 -->
          <div class="price">
            <span>単価</span>
            <div class="price-num">
              <ul v-if="list.type == '1688'">
                <li v-for="item in commodity.priceRanges" :key="item.index">
                  <span style="font-size: 20px; color: #f3c622">{{ item.price }}元</span>
                  <span>{{ item.begin }}个</span>
                </li>
              </ul>
              <ul>
                <li>
                  <span style="font-size: 20px; color: #f3c622">{{ price }}元</span>
                </li>
              </ul>
            </div>
          </div>
          <!-- <div class="distribution">
            <span>国内配送</span>
            <em>XXXXXXXXXXXXXX</em>
          </div>-->
          <!-- 部分商品没有sku 不显示颜色尺码 -->
          <div v-if="commodity.sku != false">
            <div class="colour" v-if="flag == false">
              <span>{{
                $route.query.type == "1688" ? "カラー" : "サイズ"
              }}</span>
              <div class="colour-img fl">
                <ul>
                  <li v-for="(item, index) in skuprops" :key="index" @click="getSize(index, item)"
                    v-bind:class="{ choose: index == ischoose }">
                    <img :src="item.imageUrl" :title="item.name" alt />
                    <span>{{ item.name }}</span>
                  </li>
                </ul>
                <button @click="downloadImg(2)" class="picbtn">
                  画像ダウンロード
                </button>
              </div>
            </div>
            <!-- 选择颜色 -->
            <div class="size" v-else-if="skuprops != false">
              <span>{{
                $route.query.type == "1688" ? "カラー" : "サイズ"
              }}</span>
              <ul>
                <li v-for="(item, index) in skuprops" :key="index" v-bind:class="{ choose: ischoose == index }"
                  @click="getSize(index, item,)">
                  <a href="javascript:;">{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <!-- 选择尺码 -->
            <div class="colour" v-if="isshow1 || isshow1 != ''">
              <span>{{
                $route.query.type == "1688" ? "サイズ" : "カラー"
              }}</span>
              <div class="colour-img fl">
                <ul>
                  <li v-for="(item, index) in skusize" :key="index" @click="getSize1(index, item.pic, item.name)"
                    v-bind:class="{ choose: index == ischoose1 }">
                    <img :src="item.pic" :title="item.name" alt />
                    <span>{{ item.name }}</span>
                  </li>
                </ul>
                <button @click="downloadImg(3)" class="picbtn">
                  画像ダウンロード
                </button>
              </div>
            </div>
            <!-- 选择尺码 -->
            <div class="size" v-show="isshow != undefined && isshow != ''" v-else>
              <span>{{
                $route.query.type == "1688" ? "サイズ" : "カラー"
              }}</span>

              <ul v-if="$route.query.type != '1688'">
                <li v-for="(item, index) in skusize" :key="index" v-bind:class="{ choose: index == ischoose1 }"
                  @click="getInventory1(index, item.name)">
                  <a href="javascript:;">{{ item.name }}</a>
                </li>
              </ul>
              <ul v-else>
                <!-- {{ skusize }}111111 -->
                <li v-for="(item, index) in skusize.sizes" :key="index" v-bind:class="{ choose: index == ischoose1 }"
                  @click="getInventory1(index, item.size)">
                  <a href="javascript:;">{{ item.size }}</a>
                </li>
              </ul>
            </div>
            <!-- 选择sku1 -->
            <div class="size" v-if="skusize1 != false">
              <span>-</span>
              <ul>
                <li v-for="(item, index) in skusize1" :key="index" v-bind:class="{ choose: ischoose2 == index }"
                  @click="getSize2(item.name)">
                  <a href="javascript:;">{{ item.name }}</a>
                </li>
              </ul>
            </div>

            <!-- 选择sku2 -->
            <div class="size" v-if="skusize2 != false">
              <span>-</span>
              <ul>
                <li v-for="(item, index) in skusize2" :key="index" v-bind:class="{ choose: ischoose3 == index }"
                  @click="getSize3(item.name)">
                  <a href="javascript:;">{{ item.name }}</a>
                </li>
              </ul>
            </div>
          </div>
          <!-- 数量 -->
          <div class="num">
            <span>在庫</span>
            <el-input-number v-model="num" :min="1" :max="inventory" @blur="parseint"></el-input-number>
            <em>在庫{{ inventory }}</em>
          </div>
          <!-- 小计 -->
          <div class="subtotal">
            <span>小計</span>
            <em>{{ money }}元</em>
          </div>
          <!-- 购物车 购买 -->
          <div class="purchase">
            <!-- <button
              style="margin-left: 150px"
              v-if="
                userInfo &&
                userInfo.data.can_choose_product == 1 &&
                commodity.status != 10
              "
              @click="productAdd"
              :disabled="isCheckClient"
              :class="{ checkClient: isCheckClient }"
            >
              选购
            </button> -->

            <button @click="addCart" style="margin-left: 150px" v-if="commodity.status != 10" :disabled="isCheckClient"
              :class="{ checkClient: isCheckClient }">
              買い物かごへ追加
            </button>
            <button @click="addCart('注文')" style="margin-left: 30px" v-if="commodity.status != 10"
              :disabled="isCheckClient" :class="{ checkClient: isCheckClient }">
              注文
            </button>
            <button href="javascript:;" style="margin-left: 150px" v-else>
              已停售
            </button>
          </div>
        </div>
        <!-- 商品详情 -->
      </div>
      <div class="commodity-details">
        <!-- 店铺情报 -->
        <div class="store-details fl">
          <div class="store">
            <h4>店舗情報</h4>
            <div class="store-txt">

              <p v-if="userInfo != null">
                <a href="javascript:;" class="enshrine" @click="favoriteShopAdd">お気に入り店舗 <i
                    class="el-icon-star-off"></i></a>
              </p>
              <p>
                店舗名:
                <span>{{ commodity.companyName }}</span>
              </p>
              <p>
                店舗種類：
                <span>【{{ $route.query.type }}】</span>
              </p>
              <p>
                所在地：
                <span>{{ commodity.city }}</span>
              </p>
            </div>
            <!-- <div>
              <router-link to="/">店铺</router-link>
              <router-link to="/">追加</router-link>
            </div> -->
          </div>
        </div>
        <!-- 商品详情 -->
        <div class="product-details fl">
          <div class="details-txt">
            <div class="details-title">
              <h3>商品详情</h3>
            </div>
            <div class="goodsFeatureInfo">
              <ul v-if="$route.query.type == '1688'">
                <li v-for="(item, index) in commodity.goodsFeatureInfo" :key="index">
                  <span>{{ item.name }}</span>
                  <strong>{{ item.value }}</strong>
                </li>
              </ul>
              <ul v-else>
                <li v-for="(item, index) in commodity.goodsFeatureInfo" :key="index">
                  <span>{{ item }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="details-img">
            <ol>
              <li v-html="commodity.detail"></li>
              <li></li>
            </ol>
            <!-- <iframe
              :src="'https:' + iframeHtml"
              scrolling="auto"
              width="1150px;"
              height="1000px"
              v-else
            ></iframe> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <Foot></Foot>
    <el-dialog :visible.sync="characterRecognitionDialogVisible">
      <img :src="characterRecognitionImg" alt="" width="100%" />
      <!-- <iframe
        src="http://localhost:8080/#/characterSecognition?imageUrl=https%3A%2F%2Fimg.alicdn.com%2Fimgextra%2Fi1%2F701397872%2FTB2eb_ObVXXXXaMXXXXXXXXXXXX_%21%21701397872.gif"
        style="width: 1060px; height: 800px"
      ></iframe> -->
    </el-dialog>

    <!-- <characterRecognition /> -->
  </div>
</template>
<script>
import Head from "../../components/head/Head";
import Foot from "../../components/foot/Foot";
import { mapState, mapMutations, mapActions } from "vuex";
import {
  getDetailsList,
  addCart1688,
  getDetailsList1688,
  favoriteAdd,
  productAdd,
  zhuanhuan,
  checkClient,
} from "../../api/API/details";
import { imageCharacter } from "../../api/API/home";
import { favoriteShopAdd } from "../../api/API/commodity";
import axios from "axios";
import VueJsonp from "vue-jsonp";
import JSZip from "jszip";
import FileSaver from "file-saver";
export default {
  data() {
    return {
      characterRecognitionDialogVisible: false,
      characterRecognitionImg: "",
      flag: true,
      index: 0,
      img: false,
      num: 1, // 数量
      iframeHtml: "", // 淘宝iframe详情
      money: "", // 小计
      price: "", // 淘宝单价
      isprice: "", // 没有颜色尺寸的淘宝单价
      commodity: null, // 获取得商品详情
      detailsimg: "", // 显示的图片
      inventory: "", // 库存
      skuprops: "", // 1688价格区间
      skuProp: "", //淘宝价格区间
      skusize: "", // 尺寸
      skusize1: "", // 尺寸1
      skusize2: "", // 尺寸2
      isshow: "", // 是否显示尺码
      isshow1: "", // 显示尺码 图片或者尺寸
      ischoose: 0,
      ischoose1: 0,
      ischoose2: 0,
      ischoose3: 0,
      token: localStorage.getItem("token"),
      tata: {},
      // 加入购物车参数
      list: {
        mod: "inc",
        act: "ordersys",
        str: "addCart",
        token: "",
        type: this.$route.query.type,
        iid: this.$route.query.iid,
        mi_id:this.$route.query.mi_id,
        pic: "",
        num: "",
        size: "",
        color: "",
        product_id: "",
        seller_id: "",
        company: "",
        priceRanges: "",
        price: "",
        title: "",
      },
      //  多余的sku1
      sizeSku1: "",
      //  多余的sku2
      sizeSku2: "",
      isCheckClient: false, //true为违禁品
      shipinList: [], // 视频数组
    };
  },
  components: {
    Head,
    Foot,
  },
  computed: {
    ...mapState(["userInfo", "cartCount", "Warning"]),
  },
  created() {
    this.checkClient();
    this.getDetailsList();
  },
  methods: {
    ...mapActions(["getCart"]),
    // 违禁品查询
    checkClient() {
      let datas = { iid: this.$route.query.iid };
      checkClient(datas).then((res) => {
        if (res.code != 0) {
          this.isCheckClient = true;
          this.$confirm(res.data, "提示", {
            confirmButtonText: "確定",
            type: "warning",
            center: true,
          }).then(() => { });
        }
      });
    },
    // 获取得商品详情
    getDetailsList() {
      //1688
      var list = {
        mod: "inc",
        act: "offer",
        iid: this.$route.query.iid,
        type: this.$route.query.type,
        from: this.$route.query.from,
        mi_id:this.$route.query.mi_id,
        token:this.token
      };
      getDetailsList1688(list).then((res) => {
        if (res.msg == "未获取到数据" || res.data == false) {
          this.$router.push("/error");
          return;
        }
        if (this.$route.query.type != "1688") {
          console.log(res.data);
          this.isprice = res.data.price;
          let datas = {
            city: "",
            companyName: res.data.company,
            iid: res.data.iid,
            imglist: res.data.images,
            memberId: "",
            priceRanges: [
              { begin: 1, convertPrice: res.data.price, price: res.data.price },
            ],
            shopurl: res.data.pic_url,
            sku: [],
            skuProps: [
              { value: [] },
              { value: [] },
              { value: [] },
              { value: [] },
            ],
            title: res.data.title,
            detail: res.data.desc,
            goodsFeatureInfo: res.data.props_name,
          };
          this.skuProp = res.data.skuProp; // 淘宝价格区间
          // 获取视频
          if (res.data.videos) {
            this.shipinList = res.data.videos;
          }

          var arrSku = [];
          var yanse = [];
          // 部分商品没有sku,没有sku跳过
          if (res.data.skus_new != false) {
            for (let key in res.data.skus_new) {
              arrSku.push(res.data.skus_new[key]);
              if (arrSku.length == 1) {
                arrSku[0].forEach((item) => {
                  datas.skuProps[0].value.push({
                    name: item.value,
                    imageUrl: item.pic,
                  });
                  datas.sku.push({
                    color: item.value,
                    sizes: [],
                  });
                });
              }
              if (arrSku.length == 2) {
                arrSku[1].forEach((color) => {
                  datas.skuProps[1].value.push({
                    name: color.value,
                    pic: color.pic,
                  });

                  yanse.push({
                    canBookCount: res.data.goods_sum,
                    price: res.data.price,
                    size: color.value,
                  });
                });
              }
              if (arrSku.length == 3) {
                arrSku[2].forEach((size) => {
                  datas.skuProps[2].value.push({
                    name: size.value,
                    pic: size.pic,
                  });
                });
              }
              if (arrSku.length == 4) {
                arrSku[2].forEach((size) => {
                  datas.skuProps[3].value.push({
                    name: size.value,
                    pic: size.pic,
                  });
                });
              }
            }
            //无颜色或者尺寸分类。自行加一一个颜色
            if (arrSku.length < 2) {
              yanse.push({
                canBookCount: res.data.goods_sum,
                price: res.data.price,
                size: "",
              });
            }
            datas.sku.forEach((item) => {
              item.sizes = yanse;
            });
            console.log(datas);
          }
          this.commodity = datas;
          this.detailsimg = this.commodity.imglist[0]; // 显示大图
          this.list.pic = this.commodity.imglist[0];
          this.list.company = this.commodity.companyName;
          this.skuprops = this.commodity.skuProps[0].value;
          this.skusize = this.commodity.skuProps[1].value;
          this.skusize1 = this.commodity.skuProps[2].value;
          this.skusize2 = this.commodity.skuProps[3].value;
          if (this.skusize1 != false) {
            this.sizeSku1 = this.skusize1[0].name;
          }
          if (this.skusize2 != false) {
            this.sizeSku2 = this.skusize2[0].name;
          }
          if (this.skusize != false) {
            this.list.size = this.skusize[0].name;
            this.isshow = this.skusize[0].name; // 是否显示 尺寸
          }
          this.isshow1 = this.skusize.every((item) => item.pic != "");
          console.log(this.isshow1);
          // 部分商品没有sku
          if (this.commodity.sku != false) {
            this.list.color = this.commodity.sku[0].color;
          } else {
            this.inventory = 999;
          }
          this.taobaoPrice();
        } else {
          this.commodity = res.data;
          this.detailsimg = this.commodity.imglist[0]; // 显示大图
          this.list.pic = this.commodity.imglist[0];
          this.skuprops = this.commodity.skuProps[0].value;
          this.skusize = this.commodity.sku[0];
          this.inventory = this.commodity.sku[0].sizes[0].canBookCount;
          this.isshow = this.skusize.sizes[0].size; // 是否显示 尺寸
          this.list.size = this.skusize.sizes[0].size;
          console.log(this.skusize);
          this.list.color = this.commodity.sku[0].color;
          this.money = this.commodity.priceRanges[0].price;
          this.list.company = this.commodity.companyName;
        }

        this.list.num = this.num;
        this.list.seller_id = this.commodity.memberId;
        this.list.title = this.commodity.title;
        this.list.iid = this.commodity.iid;
        this.flag = !this.commodity.skuProps[0].value.every(
          (item) => item.imageUrl != ""
        );
        // 大图跟默认选中的第一个颜色图一致
        if (this.skuprops && this.skuprops[0] && this.skuprops[0].imageUrl) {
          this.detailsimg = this.skuprops[0].imageUrl;
          this.list.pic = this.skuprops[0].imageUrl;
        }
      });
    },
    // 更改显示的图片
    showImg(url, index) {
      this.detailsimg = url;
    },
    // 获取库存
    getInventory(index) {
      this.inventory = this.commodity.sku[index].sizes[0].canBookCount;
      //   优先取这里面的价格
      let price = this.commodity.sku[index].sizes[0].price;
      if (price) {
        this.commodity.priceRanges[0].price = price;
        this.commodity.priceRanges[0].convertPrice = price;
        this.money = price * this.num;
        // 123
      }
    },
    // 获取库存
    getInventory1(index, size) {
      this.ischoose1 = index;
      this.list.size = size;
      if (this.list.type == "1688") {
        this.inventory = this.skusize.sizes[index].canBookCount;
        // sizes里有价格按照sizes价格计算
        if (this.skusize.sizes[index].price != null) {
          //   优先取这里面的价格
          let price = this.skusize.sizes[index].price;
          this.commodity.priceRanges[0].price = price;
          this.commodity.priceRanges[0].convertPrice = price;
          this.money = price * this.num;
        }
      } else {
        this.taobaoPrice();
      }
    },
    // 淘宝天猫价格
    taobaoPrice() {
      if (this.skuProp == false) {
        this.price = this.isprice;
        this.money = this.isprice;
        return false;
      }
      let colorSize = "";
      if (this.isshow != undefined && this.isshow != "") {
        colorSize = this.list.color + ":" + this.list.size;
      } else {
        colorSize = this.list.color;
      }
      if (this.sizeSku1) {
        colorSize = colorSize + ":" + this.sizeSku1;
      }
      if (this.sizeSku2) {
        colorSize = colorSize + ":" + this.sizeSku2;
      }
      for (let key in this.skuProp) {
        if (colorSize == key.substr(0, colorSize.length)) {
          this.inventory = this.skuProp[key].quantity;
          this.money = this.skuProp[key].price * this.num;
          this.price = this.skuProp[key].price;
          this.commodity.priceRanges[0].price = this.skuProp[key].price;
          break;
        }
      }
      if (!this.inventory) {
        this.isCheckClient = true;
      } else {
        this.isCheckClient = false;
      }
      this.list.price = this.money;
    },
    // 显示图片，获取尺寸，获取库存
    getSize(index, item) {
      if (this.flag == false) {
        // 显示图片
        this.showImg(item.imageUrl);
        this.list.pic = item.imageUrl;
      }
      this.ischoose = index;
      this.list.color = item.name;
      this.skusize.sizes = this.commodity.sku[index].sizes


      this.getInventory(index);
      if (this.$route.query.type != 1688) {
        this.taobaoPrice();
      }
    },
    // 淘宝图片
    getSize1(index, url, name) {
      this.ischoose1 = index;
      this.list.size = name;
      this.list.pic = url;
      this.showImg(url);
      this.taobaoPrice();
    },
    // sku 2
    getSize2(name) {
      this.sizeSku1 = name;
      this.taobaoPrice();
    },
    // sku 3
    getSize3(name) {
      this.sizeSku2 = name;
      this.taobaoPrice();
    },
    //  加入购物车
    addCart(type) {
      this.list.priceRanges = JSON.stringify(this.commodity.priceRanges);
      let color = this.list.size;
      let size = this.list.color;
      //   taobao产品调换一下
      if (this.list.type != "1688") {
        this.list.color = color;
        this.list.size = size;
      }
      if (this.userInfo == null) {
        let url = this.$route.fullPath;
        this.toPage(url);
        this.$router.push("/login");
        return false;
      }
      if (this.num < this.commodity.priceRanges[0].begin)
        return this.$message.warning("最小ロット未満");

      this.list.token = localStorage.getItem("token");
      addCart1688(this.list).then((res) => {
        if (res.code != 1) return this.$message.error("追加失敗しました");

        if (type == '注文') {
          let routeUrl = this.$router.resolve({
            path: "zhuwen?cid=" + res.data.join(','),
          });
          window.open(routeUrl.href, "_blank");
        } else {
          this.$message.success("買い物かごへ追加成功");

        }
        this.getCart();
        // 加购后转回去
        if (this.list.type != "1688") {
          this.list.color = size;
          this.list.size = color;
        }
      });
    },
    // 收藏商品
    favoriteAdd() {
      if (this.userInfo == null) {
        let url = this.$route.fullPath;
        this.toPage(url);
        this.$router.push("/login");
        return false;
      }
      let list = {
        iid: this.commodity.iid,
        pic: this.detailsimg,
        price: this.money,
        company: this.commodity.companyName,
        title: this.commodity.title,
        type: this.$route.query.type,
        memberId: this.commodity.gid,
        city: this.commodity.city,
      };
      favoriteAdd(this.token, list).then((res) => {
        if (res.code != 1) return this.$message.error(res.msg);
        this.$message.success("追加成功");
      });
    },
    parseint() {
      if (this.num >= this.inventory) {
        this.num = this.inventory;
      }
      if (this.num == undefined) {
        this.num = 1;
      }
      this.num = parseInt(this.num);
    },
    // 选购
    productAdd() {
      if (this.inventory <= 0) {
        return this.$message.error("库存不足");
      }
      let list = {
        user_id: 12,
        color: this.list.color,
        size: this.list.size,
        image: this.list.pic,
        id: this.list.skuId,
        title: this.list.title,
        stock: this.inventory,
        price: this.list.price,
      };
      console.log(list);
      productAdd(list).then((res) => {
        if (res.code == 1) this.$message.success("加购成功");
      });
    },
    downloadZip() {
      let { img_list } = this;
      let blogTitle = "啥也不是"; // 下载的文件夹名称
      let zip = new JSZip();
      let imgs = zip.folder(blogTitle);
      let baseList = [];
      for (let i = 0; i < img_list.length; i++) {
        let name = img_list[i].name; // 每张图片的名称
        let image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function () {
          let canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          let context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          let url = canvas.toDataURL(); // 得到图片的base64编码数据 let url =
          canvas.toDataURL("image/png");
          baseList.push({ name: name, img: url.substring(22) });
          if (baseList.length === img_list.length) {
            if (baseList.length > 0) {
              for (let k = 0; k < baseList.length; k++) {
                imgs.file(baseList[k].name + ".png", baseList[k].img, {
                  base64: true,
                });
              }
              zip.generateAsync({ type: "blob" }).then(function (content) {
                FileSaver.saveAs(content, blogTitle + ".zip");
              });
            }
          }
        };
        image.src = img_list[
          i
        ].baseImg = `data:image/png;base64,${img_list[i].baseImg}`;
      }
    },
    /**文件打包
     * arrImages:文件list:[{fileUrl:文件url,renameFileName:文件名}]
     * filename 压缩包名
     * */
    downloadImg(i) {
      if (this.userInfo == null) {
        let url = this.$route.fullPath;
        this.toPage(url);
        this.$router.push("/login");
        return false;
      }
      let list = [];
      if (i == 1) {
        this.commodity.imglist.forEach((item, index) => {
          list[index] = {
            fileUrl: item,
            renameFileName: "img" + (index - 0 + 1) + ".jpg",
          };
        });
      } else if (i == 2) {
        this.skuprops.forEach((item, index) => {
          list[index] = {
            fileUrl: item.imageUrl,
            renameFileName: item.name + ".jpg",
          };
        });
      } else if (i == 3) {
        this.skusize.forEach((item, index) => {
          list[index] = {
            fileUrl: item.pic,
            renameFileName: item.name + ".jpg",
          };
        });
      }

      this.filesToRar(list, "画像ダウンロード");
    },
    filesToRar(arrImages, filename) {
      let _this = this;
      let zip = new JSZip();
      let cache = {};
      let promises = [];
      _this.title = "正在加载压缩文件";
      for (let item of arrImages) {
        const promise = _this.getImgArrayBuffer(item.fileUrl).then((data) => {
          // 下载文件, 并存成ArrayBuffer对象(blob)
          zip.file(item.renameFileName, data, { binary: true }); // 逐个添加文件
          cache[item.renameFileName] = data;
        });
        promises.push(promise);
      }
      Promise.all(promises)
        .then(() => {
          zip.generateAsync({ type: "blob" }).then((content) => {
            _this.title = "正在压缩"; // 生成二进制流
            FileSaver.saveAs(content, filename); // 利用file-saver保存文件 自定义文件名
            _this.title = "压缩完成";
          });
        })
        .catch((res) => {
          _this.$message.error("文件压缩失败");
        });
    },
    //获取文件blob
    getImgArrayBuffer(url) {
      let _this = this;
      return new Promise((resolve, reject) => {
        //通过请求获取文件blob格式
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open("GET", url, true);
        xmlhttp.responseType = "blob";
        xmlhttp.onload = function () {
          if (this.status == 200) {
            console.log(this.response);
            resolve(this.response);
          } else {
            reject(this.status);
          }
        };
        xmlhttp.send();
      });
    },
    shiping() {
      let that = this;
      this.shipinList.forEach((item) => {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            // handler(this.response)
            console.log(this.response, typeof this.response);
            let blob = this.response;
            if (typeof window.navigator.msSaveBlob !== "undefined") {
              window.navigator.msSaveBlob(blob, that.commodity.title + ".mp4");
            } else {
              let URL = window.URL || window.webkitURL;
              // 使用获取到的blob对象创建的blobUrl
              const blobUrl = URL.createObjectURL(blob);
              const a = document.createElement("a");
              if (typeof a.download === "undefined") {
                window.location = blobUrl;
              } else {
                document.body.appendChild(a);
                a.style.display = "none";
                a.href = blobUrl;
                // 指定下载的文件名
                a.download = that.commodity.title + ".mp4";
                a.click();
                document.body.removeChild(a);
                // 移除blob对象的blobUrl
                URL.revokeObjectURL(blobUrl);
              }
            }
          }
        };
        xhr.open("GET", item); // 这里url替换为视频地址
        xhr.responseType = "blob";
        xhr.send();
      });
    },
    // 翻译图中的图片
    characterRecognition() {
      let list = {
        url:
          this.detailsimg.substr(0, 1) == "h"
            ? this.detailsimg
            : "https:" + this.detailsimg,
      };
      imageCharacter(list).then((res) => {
        if (res.Code != 200) return false;
        this.characterRecognitionImg = res.Data.Url;
        this.characterRecognitionDialogVisible = true;
        console.log(res);
      });
      console.log(this.detailsimg);
    },
    // 店铺收藏
    favoriteShopAdd() {
      let datas = {
        token: this.token,
        shop_type: this.$route.query.type,
        shop_name: this.commodity.companyName,
        shop_id: this.commodity.companyName,
      }
      favoriteShopAdd(datas).then(res => {
        this.$message.success("追加成功");
      })
    },
    ...mapMutations(["outInfo", "toPage"]),
  },
  watch: {
    num() {
      if (this.num < 1) {
        this.num = 1;
      }
      this.list.num = this.num;
      var count = this.commodity.priceRanges;
      if (this.$route.query.type == "1688") {
        if (count.length == 1) {
          this.money = this.num * count[0].price;
          this.list.price = this.money;
          return (this.money = this.money.toFixed(2));
        } else if (count.length == 2) {
          if (this.num < count[1].begin) {
            this.money = this.num * count[0].price;
            this.list.price = this.money;
            return (this.money = this.money.toFixed(2));
          } else if (this.num >= count[1].begin) {
            this.money = this.num * count[1].price;
            this.list.price = this.money;
            return (this.money = this.money.toFixed(2));
          }
        } else if (count.length == 3) {
          if (this.num < count[1].begin) {
            this.money = this.num * count[0].price;
            this.list.price = this.money;
            return (this.money = this.money.toFixed(2));
          } else if (
            (this.num >= count[1].begin) &
            (this.num < count[2].begin)
          ) {
            this.money = this.num * count[1].price;
            this.list.price = this.money;
            return (this.money = this.money.toFixed(2));
          } else if (this.num >= count[2].begin) {
            this.money = this.num * count[2].price;
            this.list.price = this.money;
            return (this.money = this.money.toFixed(2));
          }
        }
      } else {
        this.money = this.num * this.price;
        this.money = this.money.toFixed(2);
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  overflow: hidden;

  .main-title {
    height: 30px;
    margin: 20px auto;
    line-height: 30px;
    background: #f2f2f2;

    h6 {
      float: left;
      margin-left: 20px;
      overflow: hidden;
      font-size: 14px;
    }

    .merchant {
      float: right;
      margin-right: 20px;

      span {
        margin-left: 20px;

        img {
          vertical-align: middle;
          margin-right: 5px;
        }
      }
    }
  }

  .details {
    overflow: hidden;

    .details-img {
      margin-bottom: 74px;

      .img-box {
        width: 460px;
        height: 460px;
        border: 1px solid #ccc;
        margin-bottom: 20px;
        cursor: pointer;
        position: relative;

        .btn {
          position: absolute;
          top: 0;
          right: 0;
          z-index: 9;
          cursor: pointer;
          padding: 2px;
          background-color: #f3c622;
          color: #fff;
        }

        img {
          position: absolute;
          width: 460px;
          height: 460px;
        }

        .img {
          transform: translate(300px, 0px);
          z-index: 99999;
          width: 690px;
          height: 690px;
          transition: all ease 1s;
        }
      }

      ul {
        overflow: hidden;
        margin-bottom: 20px;
        width: 460px;
        height: 125px;

        li {
          width: 107px;
          height: 125px;
          float: left;
          margin-right: 8px;

          //   background-color: pink;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .functional {
        p {
          img {
            vertical-align: middle;
          }

          margin-bottom: 10px;
        }

        a {
          color: #333;
          font-weight: 700;
        }

        .enshrine {
          border: 1px solid #ccc;
          margin-right: 20px;

          &:hover {
            color: #f3c622;
            border: 1px solid #f3c622;
          }
        }

        .share {
          img {
            width: 18px;
            height: 20px;
            vertical-align: middle;
            margin-left: 8px;
          }
        }

        span {
          margin-left: 10px;
        }
      }
    }

    .details-select {
      width: 793px;
      margin-left: 100px;
      font-weight: 700;
      color: #333;
      margin-bottom: 30px;

      h3 {
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 10px;
      }

      p {
        font-size: 12px;
        margin-bottom: 6px;
      }

      .price {
        overflow: hidden;
        margin-bottom: 15px;

        span {
          float: left;
          font-size: 14px;
          width: 100px;
        }

        ul {
          float: left;

          li {

            // font-size: 24px;
            span {
              width: 120px;
              font-size: 20px;
            }
          }
        }
      }

      .distribution {
        font-size: 14px;
        margin-bottom: 20px;

        span {
          float: left;

          width: 80px;
        }
      }

      .colour {
        overflow: hidden;
        margin-bottom: 20px;

        span {
          float: left;
          width: 80px;
          font-size: 14px;
          line-height: 80px;
        }

        .colour-img {
          ul {
            width: 700px;

            li {
              float: left;
              position: relative;
              width: 80px;
              height: 80px;
              border: 2px solid transparent;
              margin-right: 10px;
              margin-bottom: 21px;

              &:hover span {
                display: block;
              }

              span {
                position: absolute;
                left: 0;
                bottom: -20px;
                text-align: center;
                background-color: #ccc;
                display: none;
                line-height: 20px;
                width: 100%;
                height: 20px;
                font-size: 10px;
                overflow: hidden;
              }

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }

      .size {
        // height: 32px;
        margin-bottom: 15px;
        overflow: hidden;

        span {
          float: left;
          width: 80px;
          font-size: 14px;
          line-height: 32px;
        }

        ul {
          li {
            float: left;
            height: 30px;
            margin-right: 5px;
            border: 2px solid #ccc;
            margin-bottom: 5px;

            a {
              color: #333;
              font-size: 12px;
              line-height: 30px;
              padding: 0 10px;
            }
          }
        }
      }

      .num {
        margin-bottom: 20px;

        span {
          float: left;
          width: 80px;
          font-size: 14px;
          line-height: 32px;
        }

        em {
          margin-left: 20px;
        }
      }

      .subtotal {
        span {
          float: left;
          width: 80px;
          font-size: 14px;
          line-height: 32px;
        }

        em {
          color: #f3c622;
          font-size: 24px;
          font-weight: 700;
        }
      }

      .purchase {
        button {
          display: inline-block;
          height: 42px;
          line-height: 42px;
          font-size: 18px;
          font-weight: 700;
          background: #f3c622;
          color: #333;
          padding: 0 30px;
          border-radius: 5px;
          margin-left: 60px;
          cursor: pointer;
        }

        .checkClient {
          background-color: #eee;
          color: #fff;
          cursor: no-drop;
        }
      }
    }

    .picbtn {
      margin-top: 20px;
      padding: 10px;
      font-size: 16px;
      background: #f3c622;
      color: #fff;
    }
  }

  .commodity-details {
    color: #333;

    .store-details {
      width: 238px;
      border: 1px solid #ccc;

      .store {
        font-weight: 700;

        h4 {
          text-align: center;
          height: 40px;
          background: #f2f2f2;
          line-height: 40px;
          font-size: 16px;
          border-bottom: 1px solid #ccc;
        }

        .store-txt {
          padding: 20px;

          p {
            margin-bottom: 10px;
            font-size: 14px;
          }
        }

        a {
          display: block;
          height: 30px;
          padding: 0 10px;
          border: 1px solid #ccc;
          line-height: 30px;
          color: #333;
          font-size: 14px;
          text-align: center;
          width: 120px;
          margin: 0 auto 15px;
        }
      }
    }

    .product-details {
      width: 1150px;
      margin-left: 10px;

      .details-txt {
        border: 1px solid #ccc;

        .details-title {
          height: 40px;
          background: #f2f2f2;
          border-bottom: 1px solid #ccc;

          h3 {
            width: 120px;
            text-align: center;
            line-height: 40px;
            height: 40px;
            background: #f3c622;
            font-size: 16px;
            font-weight: 700;
          }
        }

        .goodsFeatureInfo {
          overflow: hidden;
          padding: 40px;

          li {
            float: left;
            width: 250px;
            font-size: 14px;
            margin-bottom: 10px;
            font-weight: 700;

            strong {
              margin-left: 20px;
              font-weight: 500;
            }
          }
        }
      }

      .details-img {
        margin-top: 30px;
        overflow: hidden;
        padding-bottom: 100px;

        ol {
          li {
            width: 800px;
            margin: 0 auto 20px;
            background: #f2f2f2;
          }
        }
      }
    }
  }
}

.choose {
  border: 2px solid #f3c622 !important;
}

/deep/ .el-input-number__decrease {
  top: 2px;
}

/deep/ .el-input-number__increase {
  top: 2px;
}

/deep/.el-loading-mask {
  display: none !important;
}
</style>